/* eslint-disable react/no-unescaped-entities */

import React, { Fragment, useRef, useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import "./home.scss";

const Home = () => {
  const [visibleSection, setVisibleSection] = useState();
  const [isNavbarSticky, setIsNavbarSticky] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const [activeSlide, setActiveSlide] = useState(0);

  const navListItemsRef = useRef(null);
  const homeRef = useRef(null);
  const aboutRef = useRef(null);
  const reasonsRef = useRef(null);
  const productRef = useRef(null);
  const contactRef = useRef(null);
  const supportRef = useRef(null);
  const carouselRef = useRef(null);

  const appStoreLink = "https://apps.apple.com/us/app/emaan-reviver/id6444712317";
  const playStoreLink =
    "https://play.google.com/store/apps/details?id=com.emaanreviver.emaanreviver";
  const donationLink = "https://donorbox.org/emaan-reviver";

  const sectionRefs = useMemo(
    () => [
      { section: "Home", ref: homeRef },
      { section: "Product", ref: productRef },
      { section: "About Us", ref: reasonsRef },
      { section: "Be Part of Sadaqa Jariyah", ref: aboutRef },
      { section: "Contact Us", ref: contactRef },
    ],
    [],
  );

  const menuElements = [
    { name: "Home", ref: homeRef },
    { name: "Product", ref: productRef },
    { name: "About Us", ref: reasonsRef },
    { name: "Be Part of Sadaqa Jariyah", ref: aboutRef },
    { name: "Contact Us", ref: contactRef },
  ];

  const features = [
    {
      icon: "assets/svg/Like Inactive.svg",
      title: "Captivating Quotes, Images & Videos",
      description: "Share posts and bookmark your favourite videos, images & access them instantly",
      phone: "assets/img/app1.png",
    },
    {
      icon: "assets/svg/Noor AI Icon.svg",
      title: "Noor AI - Your 24/7 AI Companion",
      description: "Have any Islamic question? Ask Noor anything.",
      phone: "assets/img/app2.png",
    },
    {
      icon: "assets/svg/audio.svg",
      title: "Nourish with Audio Lectures",
      description:
        "Access an extensive library of podcast and audio lectures from renowned scholars",
      phone: "assets/img/app3.png",
    },
    {
      icon: "assets/svg/ER Shorts.svg",
      title: "ER Shorts - Wisdom in Bite-sized videos",
      description: "Dive into the world of ER shorts and unlock wisdom in short, powerful videos",
      phone: "assets/img/app4.png",
    },
  ];

  const reasons = [
    {
      emoji: "❤️",
      title: "Nurture your Emaan with daily feed",
    },
    {
      emoji: "⚡",
      title: "Gain access to profound Islamic knowledge",
    },
    {
      emoji: "🎁",
      title: "Earn never-ending rewards for your Aakhirah",
    },
    {
      emoji: "🗣️",
      title: "Share and bookmark your favourite posts",
    },
  ];

  const problems = [
    {
      emoji: "🐾",
      title: "Blind Following",
      description:
        "Many of us tend to blindly follow teachings without verifying the authenticity of the content from the Quran, Sahih Hadith, and in the noble path of Salaf-e-Saliheen",
    },
    {
      emoji: "🧲",
      title: "Fitnah and Distractions",
      description:
        "The vast amount of Haram content on social media can easily divert us from our path, leading us into the traps of Shaytan",
    },
    {
      emoji: "‼️",
      title: "Haram Advertisements",
      description:
        "The presence of Haram advertisements can accidentally expose us to forbidden content.",
    },
  ];

  // Row 1 testimonials
  const testimonialsRow1 = [
    {
      initial: "M",
      name: "Maria Abdullah",
      color: "#1a8a4a",
      text: 'I want to say thank you for creating such an amazing app for all the Muslims around the world. Very easy to use and very clean no ads etc. In Ramadan its a good way to stay away from haram apps "like tiktok" and other social media and learn about our religion. Well done brothers.👏',
    },
    {
      initial: "F",
      name: "Faiz Ahmed Khan",
      color: "#2da85f",
      text: "A must app for all the muslims. Very smooth and to the point. A very big heart to the developer for gifting us this app. May Allah reward you all with endless of happiness. JazakAllah Khair.",
    },
    {
      initial: "S",
      name: "Syed Wasiulla",
      color: "#168a4a",
      text: "Firstly I would like to say Alhamdulillah, This platform is amazing 😍 to find authentic content to increase and fresh our imaan. The thing I liked in this platform is the sources are from Qur'an and sahih Hadith. Keep going team.",
    },
    {
      initial: "U",
      name: "Umme Hani",
      color: "#f5a623",
      text: "It feels like a trusted companion on my journey to strengthen my emaan. It's spiritually nurturing. It's user friendly, smooth and gaining more of authentic knowledge from the content creators.",
    },
  ];

  // Row 2 testimonials
  const testimonialsRow2 = [
    {
      initial: "S",
      name: "Safiya Tabassum",
      color: "#1a8a4a",
      text: "In today's world of fitnah this app is wonderful ❤️ for all Muslim to be on point and to revive their emaan and never be distracted Alhamdulillah always wanted something like this where you can find all benefits in one place this is good alternative of social media all authentic posts and reels are shown here.",
    },
    {
      initial: "M",
      name: "Mohammad Kaif",
      color: "#2da85f",
      text: "Most amazing app 😍 using this app I feel good and I'm happy that my time is been utilised. JazakAllah khair, Allah humma baarik.",
    },
    {
      initial: "A",
      name: "Ahmed Ansari",
      color: "#168a4a",
      text: "I saw post on Instagram, yall should make Instagram alternative, slowly slowly yall can become youtube alternative too, mashallah I am happy.",
    },
    {
      initial: "F",
      name: "Fatima",
      color: "#f5a623",
      text: "Ma Sha Allah great app! And a great alternative for social media platforms. With great power, comes great responsibility, so I'd advise to be extra sure to rely on the Qur'an and Sunnah for your posts and data. May Allah SWT reward you!",
    },
  ];

  const testimonialsAll = [...testimonialsRow1, ...testimonialsRow2];

  const getDimensions = (ele) => {
    const { height } = ele.getBoundingClientRect();
    const { offsetTop } = ele;
    const offsetBottom = offsetTop + height;
    return { height, offsetTop, offsetBottom };
  };

  const scrollTo = (ele) => {
    ele.scrollIntoView({ behavior: "smooth", block: "start" });
    setMobileMenuOpen(false);
  };

  const handleOpenLink = (link) => {
    window.open(link, "_blank");
  };

  const goToSlide = (index) => {
    const el = carouselRef.current;
    if (!el) return;
    const first = el.querySelector(".carousel-card");
    if (!first) return;
    const cardWidth = first.getBoundingClientRect().width;
    const gap = 16;
    el.scrollTo({ left: index * (cardWidth + gap), behavior: "smooth" });
    setActiveSlide(index);
  };

  useEffect(() => {
    const el = carouselRef.current;
    if (!el) return undefined;

    // Only run this logic on mobile
    const isMobile = window.matchMedia("(max-width: 768px)").matches;
    if (!isMobile) return undefined;

    const onScroll = () => {
      const first = el.querySelector(".carousel-card");
      if (!first) return;

      const cardWidth = first.getBoundingClientRect().width;
      const gap = 16; // keep in sync with CSS gap
      const idx = Math.round(el.scrollLeft / (cardWidth + gap));
      setActiveSlide(Math.max(0, Math.min(idx, testimonialsAll.length - 1)));
    };

    el.addEventListener("scroll", onScroll, { passive: true });
    onScroll();

    return () => el.removeEventListener("scroll", onScroll);
  }, [testimonialsAll.length]);

  useEffect(() => {
    const handleStickyScroll = () => {
      const scroll = window.scrollY || window.pageYOffset;
      setIsNavbarSticky(scroll >= 20);
    };
    window.addEventListener("scroll", handleStickyScroll);
    return () => window.removeEventListener("scroll", handleStickyScroll);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (!navListItemsRef.current) return;
      const { height: headerHeight } = getDimensions(navListItemsRef.current);
      const scrollPosition = window.scrollY + headerHeight;

      const selected = sectionRefs.find(({ ref }) => {
        const ele = ref.current;
        if (ele) {
          const { offsetBottom, offsetTop } = getDimensions(ele);
          return scrollPosition > offsetTop && scrollPosition < offsetBottom;
        }
        return false;
      });

      if (selected && selected.section !== visibleSection) {
        setVisibleSection(selected.section);
      } else if (!selected && visibleSection) {
        setVisibleSection(undefined);
      }
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [visibleSection, sectionRefs]);

  useEffect(() => {
    const el = carouselRef.current;
    if (!el) return undefined;

    // Only run this logic on mobile
    const isMobile = window.matchMedia("(max-width: 768px)").matches;
    if (!isMobile) return undefined;

    const onScroll = () => {
      const first = el.querySelector(".carousel-card");
      if (!first) return;

      const cardWidth = first.getBoundingClientRect().width;
      const gap = 16; // keep in sync with CSS gap
      const idx = Math.round(el.scrollLeft / (cardWidth + gap));
      setActiveSlide(Math.max(0, Math.min(idx, testimonialsAll.length - 1)));
    };

    el.addEventListener("scroll", onScroll, { passive: true });
    onScroll();

    return () => el.removeEventListener("scroll", onScroll);
  }, [testimonialsAll.length]);

  return (
    <Fragment>
      {/* Header/Navbar */}
      <header className="header">
        <nav className={`navbar ${isNavbarSticky ? "sticky" : ""}`}>
          <Link className="navbar-brand" to="/">
            <img src="assets/img/logo.png" alt="Emaan Reviver Logo" />
            <span className="brand-name">Emaan Reviver</span>
          </Link>

          <button
            className="mobile-menu-toggle"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          <ul ref={navListItemsRef} className={`nav-menu ${mobileMenuOpen ? "open" : ""}`}>
            {menuElements.map((menu) => (
              <li
                key={menu.name}
                className={`nav-item ${visibleSection === menu.name ? "active" : ""}`}
              >
                <a onClick={() => scrollTo(menu.ref.current)}>{menu.name}</a>
              </li>
            ))}
          </ul>

          <div className="nav-buttons">
            <button
              className="store-btn"
              onClick={() => handleOpenLink(playStoreLink)}
              aria-label="Download on Play Store"
            >
              <img src="assets/svg/Google Play Black.svg" alt="Get it on Google Play" />
            </button>
            <button
              className="store-btn"
              onClick={() => handleOpenLink(appStoreLink)}
              aria-label="Download on App Store"
            >
              <img src="assets/svg/App Store Black.svg" alt="Download on App Store" />
            </button>
          </div>
        </nav>
      </header>

      <main className="home">
        {/* Hero Section */}
        <section ref={homeRef} id="home" className="hero-section">
          {/* Background-only layer (gets blurred by header) */}
          <div className="hero-bg" aria-hidden="true">
            <div className="hero-wave">
              <svg viewBox="0 0 1440 220" preserveAspectRatio="none">
                <path
                  d="M0,165 C180,95 360,70 520,95 C720,130 920,155 1120,145 C1280,138 1380,95 1440,60 L1440,220 L0,220 Z"
                  fill="#F7FDF7"
                />
              </svg>
            </div>
          </div>

          {/* Content layer (above header, not blurred) */}
          <div className="hero-content">
            <h1>
              One-stop destination to recharge
              <br />
              your emaan with <span className="highlight">authentic Islamic content</span>
            </h1>
            <p className="hero-subtitle">Alhamdulillah first social media app with halal content</p>

            <div className="hero-buttons">
              <button className="btn-primary" onClick={() => handleOpenLink(playStoreLink)}>
                Play Store
              </button>
              <button className="btn-secondary" onClick={() => handleOpenLink(appStoreLink)}>
                App Store
              </button>
            </div>
          </div>

          <div className="hero-phones">
            <img className="phone-left" src="assets/img/back-phone.png" alt="App Screenshot" />
            <img className="phone-right" src="assets/img/front-phone.png" alt="App Screenshot" />
          </div>
        </section>

        {/* Problems Section */}
        <section className="problems-section">
          <div className="problems-header">
            <div className="problems-badge">
              <img src="assets/svg/Icon.svg" alt="" />
              <span>Problems we see in today's worldly life:</span>
            </div>
          </div>

          <div className="problems-grid">
            {problems.slice(0, 2).map((problem, idx) => (
              <div key={idx} className="problem-card">
                <div className="problem-icon">{problem.emoji}</div>
                <h3>{problem.title}</h3>
                <p>{problem.description}</p>
              </div>
            ))}
          </div>

          <div className="problem-card center">
            <div className="problem-icon">{problems[2].emoji}</div>
            <h3>{problems[2].title}</h3>
            <p>{problems[2].description}</p>
          </div>
        </section>

        {/* Features Section */}
        <section ref={productRef} id="product" className="features-section">
          <div className="solution-badge-top">
            <img src="assets/svg/Like Inactive.svg" alt="" />
            <span>Solution: A place to renew your faith</span>
          </div>

          <div className="section-header">
            <h2>Recharge your Emaan with</h2>
            <h2 className="highlight">authentic Islamic Content</h2>
            <p className="section-subtitle">
              <span className="green-text">Alhamdulillah</span> - First social media app with halal
              content
            </p>
          </div>

          <div className="features-layout">
            {/* Group features into rows of 2 */}
            {Array.from({ length: Math.ceil(features.length / 2) }, (_, rowIndex) => {
              const startIdx = rowIndex * 2;
              const endIdx = startIdx + 2;
              return (
                <div className="features-row-design" key={rowIndex}>
                  {features.slice(startIdx, endIdx).map((feature, idx) => (
                    <React.Fragment key={idx}>
                      <div className="feature-text">
                        <div className="feature-icon-box">
                          <img src={feature.icon} alt="" />
                        </div>
                        <h3>{feature.title}</h3>
                        <p>{feature.description}</p>
                      </div>
                      <div className="feature-phone">
                        <img src={feature.phone} alt={feature.title} />
                      </div>
                    </React.Fragment>
                  ))}
                </div>
              );
            })}
          </div>
        </section>

        {/* Reasons Section */}
        <section ref={reasonsRef} id="about" className="reasons-section">
          <h2>Top reasons to download Emaan Reviver app</h2>
          <p className="highlight-text">Alhamdulillah</p>

          <div className="reasons-grid">
            {reasons.map((reason, idx) => (
              <div key={idx} className="reason-card">
                <div className="reason-icon">{reason.emoji}</div>
                <p>{reason.title}</p>
              </div>
            ))}
          </div>

          <div className="reasons-cards">
            <div className="video-card">
              {isVideoPlaying ? (
                <iframe
                  className="video-iframe"
                  src="https://www.youtube.com/embed/BO36a9rhwbU?autoplay=1"
                  title="Emaan Reviver Introduction"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              ) : (
                <>
                  <div
                    className="play-button"
                    onClick={() => setIsVideoPlaying(true)}
                    style={{ cursor: "pointer" }}
                  >
                    <img src="assets/svg/Play Icon.svg" alt="Play" />
                  </div>
                  <div className="video-info">
                    <h3>Watch our introduction video</h3>
                    <p>Discover how Emaan Reviver can transform your spiritual journey</p>
                  </div>
                </>
              )}
            </div>

            <div className="quote-card">
              <img src="assets/svg/Arrows.svg" alt="" className="quote-icon" />
              <p className="quote-text">
                "We want our Ummah to understand that, no matter what situation you're going
                through, there are solutions and guidance from Allah Subhanahu Wa Ta'ala"
              </p>
            </div>
          </div>
        </section>

        {/* Impact Section */}
        <section ref={aboutRef} id="about-us" className="impact-section">
          <div className="impact-badge">
            <img src="assets/svg/flower.svg" alt="" />
            <span>Be part of Sadaqa Jariyah</span>
          </div>

          <div className="impact-content">
            <h2>
              Make a Lasting Impact
              <br />
              for the Ummah
            </h2>
            <p className="impact-description">
              Your generous donations ensure the continuity of Emaan Reviver's infrastructure and
              enable us to keep the light of guidance shining bright for our beloved UMMAH. 🌟📱
            </p>

            <div className="quote-card-green">
              <div className="quote-emoji">📖</div>
              <blockquote>
                "Who is it that would loan Allah a goodly loan so He will multiply it for him and he
                will have a noble reward?"
              </blockquote>
              <cite>- Quran 57:11</cite>
            </div>

            <div className="quote-card-green">
              <div className="quote-emoji">🕌</div>
              <blockquote>
                "When a man dies all his good deeds come to an end except three: Ongoing charity
                (Sadaqah Jariyah), beneficial knowledge and a righteous son who prays for him"
              </blockquote>
              <cite>- Sunan an-Nasa'i 3651</cite>
            </div>

            <h3 className="join-title">Join us in this noble journey</h3>
            <p className="join-description">
              Where your contributions serve as a continuous source of blessings, even beyond this
              life. Make a lasting impact, become an active donor of Emaan Reviver, and share the
              endless rewards with our UMMAH.
            </p>

            <div className="donate-row">
              <button className="btn-donate" onClick={() => handleOpenLink(donationLink)}>
                Donate Now!
              </button>
              <span className="donate-text">Every contribution makes a difference</span>
            </div>

            <p className="blessing-text">
              May Allah Subahanu wa Ta'ala bless you and your family members abundantly for your
              generosity and make your support a means of immense reward in this world and the
              Hereafter. 🏠🌟👨‍👩‍👧‍👦 (Aameen)
            </p>

            <p className="jazak-text">
              <strong>
                Jazakum Allahu Khairan Katheeran for being a guiding light in our mission to revive
                Emaan globally.
              </strong>{" "}
              🌍🌟✨
            </p>
          </div>
        </section>

        {/* Join Section - Hidden, content moved to impact */}
        <section ref={supportRef} id="support-us" className="join-section hidden">
          <h2>Join us in this noble journey</h2>
          <p>
            Emaan your contributions serve as a continuous source of blessings, even beyond this
            life. Make a lasting impact, become an active donor of Emaan Reviver, and share the
            endless rewards with our UMMAH.
          </p>

          <div className="join-buttons">
            <button className="btn-donate" onClick={() => handleOpenLink(donationLink)}>
              Donate Now!
            </button>
            <button className="btn-difference">Help us to make difference!</button>
          </div>

          <p className="blessing-text">
            May Allah Subahanu wa Ta'ala bless you and your family members abundantly for your
            generosity and make your support a means of immense reward in this world and the
            Hereafter. (Ameen)
          </p>
          <p className="jazak-text">
            Jazak'Allahu Khairan for being a guiding light in our mission to revive Emaan globally.
            🌍🌟
          </p>
        </section>

        {/* Testimonials Section with Marquee Animation */}
        <section className="testimonials-section">
          <div className="feedback-badge">
            <img src="assets/svg/Like Inactive.svg" alt="" />
            <span>Feedback from our beloved users</span>
          </div>

          <div className="testimonials-header">
            <h2 className="title">
              <span className="dark">What</span> Our <span className="green">Ummah Says</span>
            </h2>
            <p className="subtitle">
              Beautiful testimonials from our beloved community members who are experiencing
              spiritual transformation with Emaan Reviver,{" "}
              <span className="green">Alhamdulillah</span>
            </p>
          </div>

          <div className="testimonials-marquee">
            {/* Fade overlays */}
            <div className="fade-overlay left" />
            <div className="fade-overlay right" />

            {/* Row 1 - moves left */}
            <div className="marquee-row">
              <div className="marquee-track track-left">
                {/* Duplicate content for seamless loop */}
                {[...testimonialsRow1, ...testimonialsRow1].map((t, idx) => (
                  <div className="t-card" key={`r1-${idx}`}>
                    <div className="t-quote">
                      <img src="assets/svg/quote.svg" alt="" />
                    </div>
                    <div className="t-stars">
                      <img src="assets/svg/Stars.svg" alt="" />
                    </div>
                    <div className="t-author">
                      <div className="t-avatar" style={{ backgroundColor: t.color }}>
                        {t.initial}
                      </div>
                      <div className="t-name">{t.name}</div>
                    </div>
                    <p className="t-text">{t.text}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Row 2 - moves right */}
            <div className="marquee-row">
              <div className="marquee-track track-right">
                {/* Duplicate content for seamless loop */}
                {[...testimonialsRow2, ...testimonialsRow2].map((t, idx) => (
                  <div className="t-card" key={`r2-${idx}`}>
                    <div className="t-quote">
                      <img src="assets/svg/quote.svg" alt="" />
                    </div>
                    <div className="t-stars">
                      <img src="assets/svg/Stars.svg" alt="" />
                    </div>
                    <div className="t-author">
                      <div className="t-avatar" style={{ backgroundColor: t.color }}>
                        {t.initial}
                      </div>
                      <div className="t-name">{t.name}</div>
                    </div>
                    <p className="t-text">{t.text}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
          {/* Mobile-only carousel (doesn't affect desktop) */}
          <div className="testimonials-carousel">
            <div ref={carouselRef} className="carousel-viewport">
              {testimonialsAll.map((t, idx) => (
                <div className="carousel-card" key={`mob-${idx}`}>
                  <div className="t-quote">
                    <img src="assets/svg/quote.svg" alt="" />
                  </div>

                  <div className="t-stars">
                    <img src="assets/svg/Stars.svg" alt="" />
                  </div>

                  <div className="t-author">
                    <div className="t-avatar" style={{ backgroundColor: t.color }}>
                      {t.initial}
                    </div>
                    <div className="t-name">{t.name}</div>
                  </div>

                  <p className="t-text">{t.text}</p>
                </div>
              ))}
            </div>

            <div className="carousel-dots" aria-label="Testimonials navigation">
              {testimonialsAll.map((_, i) => (
                <button
                  key={`dot-${i}`}
                  type="button"
                  className={`dot ${activeSlide === i ? "active" : ""}`}
                  onClick={() => goToSlide(i)}
                  aria-label={`Go to testimonial ${i + 1}`}
                />
              ))}
            </div>
          </div>
        </section>

        {/* Download CTA Section (matches screenshot) */}
        <section className="download-cta-section">
          <div className="cta-card">
            <button className="cta-pill" onClick={() => handleOpenLink(playStoreLink)}>
              Start Your Emaan Journey Now!
            </button>

            <h2 className="cta-title">
              Be Part of <span className="green">Our Growing</span> Ummah
            </h2>

            <p className="cta-subtitle">
              Experience the same spiritual transformation that thousands of Muslims around the
              world are experiencing with Emaan Reviver. Start your journey today.
            </p>

            <div className="cta-stores">
              <button className="store-btn" onClick={() => handleOpenLink(playStoreLink)}>
                <img src="assets/svg/Google Play Black.svg" alt="Get it on Google Play" />
              </button>
              <button className="store-btn" onClick={() => handleOpenLink(appStoreLink)}>
                <img src="assets/svg/App Store Black.svg" alt="Download on App Store" />
              </button>
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer ref={contactRef} id="contact-us" className="footer footer-design">
          <div className="footer-top footer-3-col">
            {/* Download section */}
            <div className="footer-block">
              <h4>Download the app now</h4>
              <div className="footer-store-buttons">
                <button
                  className="footer-btn primary"
                  onClick={() => handleOpenLink(playStoreLink)}
                >
                  Playstore
                </button>
                <button className="footer-btn ghost" onClick={() => handleOpenLink(appStoreLink)}>
                  App store
                </button>
              </div>
            </div>

            {/* Get in Touch section */}
            <div className="footer-block">
              <h4>Get in Touch</h4>
              <a className="footer-mail" href="mailto:info@emaanreviver.com">
                info@emaanreviver.com
              </a>
            </div>

            {/* Quick Links section */}
            <div className="footer-block">
              <h4>Quick Links</h4>
              <div className="footer-links-row">
                <Link to="/privacy-policy">Privacy &amp; Policy</Link>
                <Link to="/terms-conditions">Terms &amp; Conditions</Link>
              </div>
            </div>
          </div>

          <div className="footer-divider" />

          <div className="footer-bottom-design">
            <div className="footer-watermark">EMAAN REVIVER</div>
            <div className="footer-copy">© 2026 Emaan Reviver. All rights reserved.</div>
          </div>
        </footer>
      </main>
    </Fragment>
  );
};

export default Home;
